// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"71a70b4d","239":"93ddb5f6","455":"b10bd97b","977":"56e57987"}[chunkId] + ".chunk.js";
};